import React, { useEffect, useState } from "react";
import { getDataFromCmsApi } from "../../api/contentful-service";
import { parseHtml } from "../../utils/utils";
import ExecMemberCard from "../../components/cards/slide-up-cards/exec-member-card";

const ExecTeam = () => {
  const [atcInformation, setAtcInformation] = useState();

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    // get team members info
    const result = await getDataFromCmsApi("webpage/execTeam");
    setAtcInformation(result);
  };

  return (
    <div className="justify-content-center align-items-center container pb-5">
      <h1 className="display-4 text-center m-2 m-md-4 py-3">{atcInformation?.pageTitle}</h1>
      {parseHtml(atcInformation?.content)}
      <div className="py-4">
        {atcInformation?.components?.map((item) => (
          <div className="d-flex flex-wrap justify-content-center">
            {item?.items?.map((member, index) => (
              <ExecMemberCard key={index} member={member} />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
export default ExecTeam;
